export default "__VITE_ASSET__B78lho8D__"